





















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { EmoticonEntity } from '@/entities/emoticon.entity';
import { mapActions, mapGetters } from 'vuex';
import { UseService } from '@/services/service';
import LikeIcon from '@/components/Helper/Icon/Svg/LikeIcon.vue';
import { colors as vuetifyColor } from 'vuetify/lib';
import PostReactionService from '@/services/post-reaction.service';

@Component<AddReactionBtn>({
  components: { LikeIcon },
  computed: {
    ...mapGetters('emoticon', ['emoticons']),
  },
  methods: {
    ...mapActions('emoticon', ['fetchEmoticons']),
  },
})
export default class AddReactionBtn extends Vue {
  vuetifyColor = vuetifyColor;
  isReact = false;
  emoticons!: EmoticonEntity[];

  fetchEmoticons!: () => Promise<void>;

  @UseService(PostReactionService)
  service: PostReactionService;

  @Prop({ type: [String, Number], required: true })
  postId: string | number;

  async mounted() {
    if (this.emoticons.length === 0) {
      await this.fetchEmoticons();
    }
  }

  /**
   * Request to add the reaction to the server
   * @param id 
   */
  async createReaction(emoticon) {
    console.log(emoticon)
     if(!this.isReact) {
      this.isReact = true;
      this.service.createOne({
        emoticonId: emoticon.id,
        postId: this.postId as number,
      });
      const reaction = {
        count: '1',
        emoticon: emoticon as EmoticonEntity,
        emoticonId: emoticon.id,
        id: emoticon.id,
        postId: this.postId as number,
      }
      // Call update the reactions of the parent
      this.$emit('reaction', reaction);
      this.isReact = false
    }
    
  }
}
